import React from 'react';
import { ManageBusinesses } from '@/components/business';

export const ManageBusinessPage: React.FC = () => {
  return <ManageBusinesses />;
};
